<!-- 添加型号内存到task -->
<template>
    <span>优化:有值组合能被空组合替代</span>
    <div>
        <!-- {{ tempmodellevellist }}??<br> -->
        <!-- <el-button type="success">批量添加</el-button> -->
        <el-scrollbar max-height="600px">
            <el-table @selection-change="handleSelectionChange" :data="dofilterandsort(filterwordcheckList)">
                <!-- id -->
                <!-- <el-table-column v-if="false" label="id" min-width="200px">
                <template #default="scope">
                    {{ scope.row.id }}
                </template></el-table-column> -->
                <!-- 编号 -->
                <!-- <el-table-column label="编号" max-width="100px">
                <template #default="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column> -->
                <el-table-column type="selection" width="55"> </el-table-column>

                <!-- 品牌 -->
                <el-table-column label="型号" min-width="100px">
                    <template #default="scope">
                        {{ scope.row.modelName }}
                    </template>
                </el-table-column>

                <!-- 内存组合 -->
                <el-table-column label="内存组合" max-width="200px">
                    <template #default="scope">
                        <div style="display: flex">
                            <el-select v-model="tempmodellevellist[scope.$index]" name="" id="" multiple clearable>
                                <el-option v-for="ram in scope.row.ramStorage" :key="ram" :label="ram" :value="ram" />
                            </el-select>
                        </div>
                    </template>
                </el-table-column>

                <!-- 操作列 -->
                <el-table-column label="操作" header-align="center" align="center" max-width="100px">
                    <template v-slot="scope">
                        <el-button type="warning" @click="addtotask(scope.$index, scope.row)">添加</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-scrollbar>
    </div>
</template>
<script>
    import axios from "axios";

    export default {
        props: {
            brandIdselect: {
                required: true, // 指定该数据是必需的
                default: "", // 指定默认值
            },
        },
        emits: ["listenmodelleveladd", "listenmodellevelshowdialog", "modelCheck"],
        data() {
            return {
                getmodellevelURL: "/api/warePrice/getModelRamStorage",
                filterwordcheckList: [],
                tempmodellevellist: [],
                modelCheckAll: [],
            };
        },
        methods: {
            // 去重并排序
            dofilterandsort(models) {
                // 去重操作：按 modelName 去重，并合并 ramStorage
                const uniqueModels = Array.from(
                    new Map(
                        models.map((item) => {
                            return [item.modelName, item];
                        })
                    ).values()
                ).map((item) => {
                    // 合并 ramStorage，并去重
                    const allRamStorage = [...new Set(item.ramStorage)];
                    return { ...item, ramStorage: allRamStorage };
                });

                // 对模型进行排序，按 modelName 升序
                uniqueModels.sort((b, a) => a.modelName.localeCompare(b.modelName));

                return uniqueModels;
            },
            //全选
            handleSelectionChange(val) {
                this.$emit("modelCheck", val);
            },

            // 添加到模板
            addtotask(index, row) {
                let tempvar;
                if (this.tempmodellevellist[index] && this.tempmodellevellist[index].length !== 0) {
                    tempvar = {
                        brandId: this.brandIdselect,
                        modelId: row.modelId,
                        ramStorage: this.tempmodellevellist[index],
                    };
                } else {
                    tempvar = {
                        brandId: this.brandIdselect,
                        modelId: row.modelId,
                        ramStorage: null,
                    };
                }
                this.$emit("listenmodelleveladd", tempvar, row.modelName);
            },

            // 获取型号等级
            getmodellevel(brandId) {
                if (brandId == null) {
                    brandId = this.brandIdselect;
                }
                this.filterwordcheckList = [];
                axios
                    .get(this.getmodellevelURL + "/" + brandId, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        // params: {
                        //     brandId: this.brandIdselect
                        // }
                    })
                    .then((res) => {
                        if (res.data.success) {
                            this.filterwordcheckList = res.data.data;
                            this.tempmodellevellist = [];
                            this.$emit("listenmodellevelshowdialog", true);
                        } else {
                            this.$message.error(res.data.status);
                            this.$emit("listenmodellevelshowdialog", false);
                        }
                    })
                    .catch((error) => {
                        if (error.response) {
                            if (error.response.status === 404) {
                                this.$message.error("资源请求错误 (404)");
                                this.$emit("listenmodellevelshowdialog", false);
                            } else {
                                this.$message.error("An error occurred: " + error.response.status);
                            }
                        } else if (error.request) {
                            this.$message.error("服务器未响应..");
                        } else {
                            this.$message.error("Error: " + error.message);
                        }
                    });
            },
        },
        created() {
            this.getmodellevel();
        },
    };
</script>

<style lang="scss" scoped></style>
